/**
 * Wave chat-instant · ChatWindowsRoot
 *
 * Renderiza todas as ChatWindow abertas — uma por conversation cuja
 * window está open=true. Mobile permite apenas 1 visível (CSS hide
 * extra), desktop empilha lado-a-lado via prop `slot`.
 *
 * Lê apenas a Map de windows do store (zustand) — não tem lógica
 * própria, só roteia o render.
 */

import { useChatInstantStore } from '@/store/chat-instant.store';
import { ChatWindow } from './ChatWindow';
import { useAuth } from '@/store/auth.store';
import { useEffect, useState } from 'react';

const SOUND_KEY = 'chat.soundEnabled';

export function ChatWindowsRoot() {
  const user = useAuth((s) => s.user);
  const windows = useChatInstantStore((s) => s.windows);
  const [soundEnabled, setSoundEnabled] = useState<boolean>(true);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      const raw = window.localStorage?.getItem(SOUND_KEY);
      setSoundEnabled(raw !== '0');
    } catch {
      setSoundEnabled(true);
    }
  }, []);

  if (!user) return null;

  const openWindows = [...windows.values()].filter((w) => w.open);
  if (openWindows.length === 0) return null;

  return (
    <>
      {openWindows.map((w, i) => (
        <ChatWindow
          key={w.conversationId}
          conversationId={w.conversationId}
          slot={i}
          soundEnabled={soundEnabled}
        />
      ))}
    </>
  );
}
